import Vue from 'vue';
import VueRouter from 'vue-router';
//profile
import accessoryRoutes from './accessory';
import optionRoutes from './option';
import controlunitRoutes from './controlunit';
import industrialcomputerRoutes from './industrialcomputer';
import operatingsystemRoutes from './operatingsystem';
import machineRoutes from './machine';
import machinemodelRoutes from './machinemodel';
import materialRoutes from './material';
import materialcolorRoutes from './materialcolor';
import materialfeedspecRoutes from './materialfeedspec';
import materialmanufacturerRoutes from './materialmanufacturer';
import materialmediumRoutes from './materialmedium';
import materialstateRoutes from './materialstate';
import materialsupplyRoutes from './materialsupply';
import materialsupplysubRoutes from './materialsupplysub';
import materialtypeRoutes from './materialtype';
import nozzleRoutes from './nozzle';
import nozzleinRoutes from './nozzlein';
import nozzlemanufacturerRoutes from './nozzlemanufacturer';
import nozzlematerialRoutes from './nozzlematerial';
import nozzleoutRoutes from './nozzleout';
import nozzletypeRoutes from './nozzletype';
import nozzlevisualRoutes from './nozzlevisual';
import printingsurfaceRoutes from './printingsurface';
import printingsurfacematerialRoutes from './printingsurfacematerial';
import printingsurfacesizeRoutes from './printingsurfacesize';
import printingsurfacethicknessRoutes from './printingsurfacethickness';
import profilebenchmarkRoutes from './profilebenchmark';
import profileparameterRoutes from './profileparameter';
import profileparametersetRoutes from './profileparameterset';
import profileparametersetvalueRoutes from './profileparametersetvalue';
import profilestrategyRoutes from './profilestrategy';
import profilestrategyqualityRoutes from './profilestrategyquality';
import profiletoolRoutes from './profiletool';
import qualityRoutes from './quality';
import qualityfocusRoutes from './qualityfocus';
import qualitylayerRoutes from './qualitylayer';
import scoreRoutes from './score';
import sectionparameterRoutes from './sectionparameter';
import setupdefinitionRoutes from './setupdefinition';
import setupdefinitionsubRoutes from './setupdefinitionsub';
import softwareRoutes from './software';
import softwareversionRoutes from './softwareversion';
import toolRoutes from './tool';
import toolextruderRoutes from './toolextruder';
import toolheadRoutes from './toolhead';
import toolheadsubRoutes from './toolheadsub';
import toolheaterRoutes from './toolheater';
import producttypefiletypeRoutes from './producttypefiletype';
import producttypefileRoutes from './producttypefile';
import profilefileRoutes from './profilefile';

import articleRoutes from './article';
import designfileRoutes from './designfile';
import designfiletypeRoutes from './designfiletype';

import materialproductRoutes from './materialproduct';
import materialproductversionRoutes from './materialproductversion';
import materialproductlotRoutes from './materialproductlot';
//version
import linkRoutes from './link';
import changelogRoutes from './changelog';
//QualityCheck
import customerRoutes from './customer';
import contactRoutes from './contact';
import distributorRoutes from './distributor';
import productRoutes from './product';
import productdataRoutes from './productdata';
import productstatusRoutes from './productstatus';
import qualitycheckRoutes from './qualitycheck';
import qualitychecktestRoutes from './qualitychecktest';
import qualitycheckvalueRoutes from './qualitycheckvalue';
import qualitycheckvaluetypeRoutes from './qualitycheckvaluetype';
//ticket
import priorityRoutes from './priority';
import bugtypeRoutes from './bugtype';
import actiontypeRoutes from './actiontype';
import ticketstatusRoutes from './ticketstatus';
import ticketoriginRoutes from './ticketorigin';
import ticketactionRoutes from './ticketaction';
import ticketRoutes from './ticket';
import contractRoutes from './contract';
import contracttypeRoutes from './contracttype';
import tagRoutes from './tag';
//Process
import serviceRoutes from './service';
import processschemaRoutes from './processschema';
import macrotypeRoutes from './macrotype';
import processtypeRoutes from './processtype';
import processRoutes from './process';
import stepRoutes from './step';
//user
import userRoutes from './user';
import forgotpasswordRoutes from './forgotpassword';
import connexionuserRoutes from './connexionuser';
import homeRoutes from './home';
import loginRoutes from './login';
import profilRoutes from './profil';
import notificationRoutes from './notification';
import profiluserRoutes from './profiluser';
import securityparameterRoutes from './securityparameter';
import backupRoutes from './backup';
import gifRoutes from './gif';
import badgeRoutes from './badge';
import profilinterfaceRoutes from './profilinterface';
import applicationRoutes from './application';

Vue.use(VueRouter);

export default new VueRouter({
  mode: 'history',
  routes: [
            accessoryRoutes,
            optionRoutes,
            controlunitRoutes,
            industrialcomputerRoutes,
            operatingsystemRoutes,
            machineRoutes,
            machinemodelRoutes,
            materialRoutes,
            materialcolorRoutes,
            materialfeedspecRoutes,
            materialmanufacturerRoutes,
            materialmediumRoutes,
            materialstateRoutes,
            materialsupplyRoutes,
            materialsupplysubRoutes,
            materialtypeRoutes,
            nozzleRoutes,
            nozzleinRoutes,
            nozzlemanufacturerRoutes,
            nozzlematerialRoutes,
            nozzleoutRoutes,
            nozzletypeRoutes,
            nozzlevisualRoutes,
            printingsurfaceRoutes,
            printingsurfacematerialRoutes,
            printingsurfacesizeRoutes,
            printingsurfacethicknessRoutes,
            profilebenchmarkRoutes,
            profileparameterRoutes,
            profileparametersetRoutes,
            profileparametersetvalueRoutes,
            profilestrategyRoutes,
            profilestrategyqualityRoutes,
            profiletoolRoutes,
            qualityRoutes,
            qualityfocusRoutes,
            qualitylayerRoutes,
            scoreRoutes,
            sectionparameterRoutes,
            setupdefinitionRoutes,
            setupdefinitionsubRoutes,
            softwareRoutes,
            softwareversionRoutes,
            toolRoutes,
            toolextruderRoutes,
            toolheadRoutes,
            toolheadsubRoutes,
            toolheaterRoutes,
            articleRoutes,
            producttypefiletypeRoutes,
            producttypefileRoutes,
            profilefileRoutes,

            materialproductRoutes,
            materialproductversionRoutes,
            materialproductlotRoutes,
            designfileRoutes,
            designfiletypeRoutes,

            linkRoutes,
            changelogRoutes,

            serviceRoutes,
            processschemaRoutes,
            macrotypeRoutes,
            processtypeRoutes,
            processRoutes,
            stepRoutes,

            customerRoutes,
            contactRoutes,
            contractRoutes,
            contracttypeRoutes,

            distributorRoutes,
            productRoutes,
            productdataRoutes,
            productstatusRoutes,
            qualitycheckRoutes,
            qualitychecktestRoutes,
            qualitycheckvalueRoutes,
            qualitycheckvaluetypeRoutes,

            bugtypeRoutes,
            priorityRoutes,
            actiontypeRoutes,
            ticketstatusRoutes,
            ticketoriginRoutes,
            ticketactionRoutes,
            ticketRoutes,
            tagRoutes,

            userRoutes,
            forgotpasswordRoutes,
            connexionuserRoutes,
            profiluserRoutes,
            securityparameterRoutes,
            homeRoutes,
            loginRoutes,
            profilRoutes,
            notificationRoutes,
            profilinterfaceRoutes,
            gifRoutes,
            badgeRoutes,
            applicationRoutes,
            backupRoutes,
          ]
});
